module.exports = __webpack_public_path__ + "img/icon-eti-no-text.031fa8d7.svg";